import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { isType } from './isType'

export const isPlaybackActionTreeRight = (
  actionModel?: WpsRuntime.atv.wps.PlaybackActionTreeModelProps
): actionModel is WpsRuntime.atv.wps.PlaybackActionTreeRightProps =>
  isType(actionModel, 'atv.wps#PlaybackActionTreeRight')

const getMainPlayback = (
  playbackActions?: WpsRuntime.atv.wps.PlaybackActionsModelProps
) => playbackActions && playbackActions.main && isPlaybackActionTreeRight(playbackActions.main) && playbackActions.main

export const getFirstPlaybackData = (
  playbackActions?: WpsRuntime.atv.wps.PlaybackActionsModelProps
) => {
  const mainPlayback = getMainPlayback(playbackActions)
  return mainPlayback && mainPlayback.children && mainPlayback.children[0] || undefined
}

export const getPlaybackIds = (
  playbackActions?: WpsRuntime.atv.wps.PlaybackActionsModelProps
) => {
  const mainPlayback = getMainPlayback(playbackActions)
  return mainPlayback && mainPlayback.children && mainPlayback.children.map(action => action.playbackID) || undefined
}

export const getPlaybackSecondaryMessages = (
  playbackActions?: WpsRuntime.atv.wps.PlaybackActionsModelProps
) => {
  const mainPlayback = getMainPlayback(playbackActions)
  return mainPlayback && mainPlayback.metadata && mainPlayback.metadata.secondaryMessages || undefined
}

